export default __webpack_public_path__ + "images/assets/a9a748ae59cd166d8f0fa0aa51c7d1aa.svg";